import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddGameResultLayer } from '../components/GameResult/AddGameResultLayer'

export const AddGameResultPage = () => {
  return (
    <MasterLayout>
        <AddGameResultLayer />
    </MasterLayout>
  )
}
